module.exports = __webpack_public_path__ + "static/neon@1.5x-5bc3f0b86fb2c1405c38ad24b3770d43.png";